/* Octaflow -> Klaviyo bridge · 2026-09-24
   Connects the intake results gate and the book-a-call form to Klaviyo (client API, public key only).
   Loaded after octaflow.js. It does not change any existing behaviour or design: it only listens.
   - "Email me my results"  -> event "Intake Completed" (+ list subscribe, consent box is required by the gate)
   - "Book a call" (results) -> event "Call Requested"  (+ list subscribe)
   - /book form submit       -> event "Call Requested"
*/
(function(){
  var KEY='RJSueC', LIST='WpkijP', REV='2024-10-15', API='https://a.klaviyo.com/client/';
  var EMAIL_RE=/^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function post(path, body){
    try{
      return fetch(API+path+'/?company_id='+KEY,{
        method:'POST',
        headers:{'Content-Type':'application/vnd.api+json','accept':'application/vnd.api+json','revision':REV},
        body:JSON.stringify(body),
        keepalive:true
      }).catch(function(){});
    }catch(e){}
  }
  function uid(){return Date.now().toString(36)+Math.random().toString(36).slice(2,8);}

  function track(name, email, props){
    post('events',{data:{type:'event',attributes:{
      metric:{data:{type:'metric',attributes:{name:name}}},
      profile:{data:{type:'profile',attributes:{email:email}}},
      unique_id:name.replace(/\s+/g,'-').toLowerCase()+'-'+uid(),
      properties:props||{}
    }}});
  }
  function subscribe(email, source){
    post('subscriptions',{data:{type:'subscription',attributes:{
      custom_source:source,
      profile:{data:{type:'profile',attributes:{email:email,
        subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}
    },relationships:{list:{data:{type:'list',id:LIST}}}}});
  }

  /* Build the itemised results exactly as the page shows them. */
  function results(){
    try{
      if(typeof vRecommend!=='function'||typeof CONFIG==='undefined')return null;
      var rec=vRecommend();
      var items=rec.items.map(function(id){
        var it=CONFIG.catalogue[id], di=rec.depths[id], d=CONFIG.depths[di];
        var handle=(typeof VHANDLES!=='undefined')?VHANDLES[it.ref]:null;
        return {
          name:it.name,
          depth_name:d.name,
          depth:d.key,
          price:'$'+it.p[di].toLocaleString('en-US'),
          value:it.p[di],
          sku:it.ref+'-L'+(di+1),
          url:handle?'https://octaflow.com/products/'+handle:'https://octaflow.com/pages/start'
        };
      });
      return {rec:rec, items:items};
    }catch(e){return null;}
  }
  function answers(){
    try{return {category:vstate.cat,trigger:vstate.trigger,size:vstate.size,intent:vstate.intent,maturity:vstate.maturity};}
    catch(e){return {};}
  }

  /* Results gate: capture phase, so it runs before the page swaps the panel.
     Same validation as the page's own gate (valid email + consent ticked). */
  document.addEventListener('click',function(e){
    var btn=e.target&&e.target.closest?e.target.closest('#vsend,#vbook'):null;
    if(!btn)return;
    var panel=btn.closest('.vgate')||document;
    var emailEl=panel.querySelector('#vemail'), consentEl=panel.querySelector('#vconsent');
    if(!emailEl||!consentEl)return;
    var email=emailEl.value.trim();
    if(!EMAIL_RE.test(email)||!consentEl.checked)return;
    var r=results(); var a=answers();
    var props={items:r?r.items:[], result_category:r?r.rec.cat:null, cta_mode:r?r.rec.ctaMode:null};
    for(var k in a)props[k]=a[k];
    if(btn.id==='vsend'){
      track('Intake Completed',email,props);
    }else{
      props.requested_from='results_gate';
      props.preferred_window='To agree by email';
      track('Call Requested',email,props);
    }
    subscribe(email,'Octaflow intake');
  },true);

  /* /book form: bubble phase, after the page's own validation has run. */
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||form.id!=='bform')return;
    var err=document.getElementById('berr');
    if(err&&err.classList.contains('show'))return;
    var fd=new FormData(form), email=(fd.get('email')||'').toString().trim();
    if(!EMAIL_RE.test(email))return;
    var dates=form.querySelectorAll('input[name="date"]'), times=form.querySelectorAll('input[name="time"]'), slots=[];
    for(var i=0;i<dates.length;i++){ if(dates[i].value&&times[i]&&times[i].value) slots.push({date:dates[i].value,time:times[i].value}); }
    var tz=(fd.get('tz')||'').toString();
    track('Call Requested',email,{
      requested_from:'book_page',
      name:(fd.get('name')||'').toString(),
      company:(fd.get('company')||'').toString(),
      situation:(fd.get('situation')||'').toString(),
      slots:slots, tz:tz,
      preferred_window:slots.map(function(s){return s.date+' '+s.time;}).join(', ')+(tz?' ('+tz+')':'')
    });
  },false);
})();
